// eslint-disable-next-line import/no-extraneous-dependencies
import "whatwg-fetch";
import { EventSourcePolyfill, NativeEventSource } from "event-source-polyfill";

const EventSource = NativeEventSource || EventSourcePolyfill;

export const REQUEST_UPI_VERIFY_VPA = "REQUEST_UPI_VERIFY_VPA";
export const RECEIVE_UPI_VERIFY_VPA = "RECEIVE_UPI_VERIFY_VPA";
export const RECEIVE_ERROR_UPI_VERIFY_VPA = "RECEIVE_ERROR_UPI_VERIFY_VPA";

export const REQUEST_UPI_MERCHANT_COLLECT_DATA =
  "REQUEST_UPI_MERCHANT_COLLECT_DATA";
export const RECEIVE_UPI_MERCHANT_COLLECT_DATA =
  "RECEIVE_UPI_MERCHANT_COLLECT_DATA";
export const RECEIVE_ERROR_UPI_MERCHANT_COLLECT =
  "RECEIVE_ERROR_UPI_MERCHANT_COLLECT";

export const REQUEST_UPI_TRS_STATUS = "REQUEST_UPI_TRS_STATUS";
export const RECEIVE_UPI_QR = "RECEIVE_UPI_QR";
export const REQUEST_UPI_QR = "REQUEST_UPI_QR";
export const RESET_UPI_QR = "RESET_UPI_QR";
export const REQUEST_POLLING_UPI_QR_TRANSACTION_STATUS =
  "REQUEST_POLLING_UPI_QR_TRANSACTION_STATUS";

export const RESPONSE_POLLING_UPI_QR_TRANSACTION_STATUS =
  "RESPONSE_POLLING_UPI_QR_TRANSACTION_STATUS";

function requestVerifyUpiVPA(uuid, vpa) {
  return { type: REQUEST_UPI_VERIFY_VPA, uuid, vpa };
}

function receiveUpiVerifyResponse(customerName, vpa) {
  return { type: RECEIVE_UPI_VERIFY_VPA, customerName, vpa };
}

function receiveErrorUpiVerifyVpa(errorMsg) {
  return { type: RECEIVE_ERROR_UPI_VERIFY_VPA, errorMsg };
}

function requestUpiMerchantCollectData(uuid, vpa) {
  return { type: REQUEST_UPI_MERCHANT_COLLECT_DATA, uuid, vpa };
}

function receiveUpiMerchantCollectData({ transactionUuid, payapp }) {
  return {
    type: RECEIVE_UPI_MERCHANT_COLLECT_DATA,
    trsUuid: transactionUuid,
    payapp
  };
}

function receiveErrorUpiMerchantCollect(errorMsg) {
  return { type: RECEIVE_ERROR_UPI_MERCHANT_COLLECT, errorMsg };
}

function requestUpiQR() {
  return { type: REQUEST_UPI_QR };
}

function receiveUpiQRData(data) {
  return { type: RECEIVE_UPI_QR, data };
}

function receiveUpiQRError(error) {
  return { type: RECEIVE_UPI_QR, error };
}

function resetUpiQR() {
  return { type: RESET_UPI_QR };
}

function requestPollingUpiQRTRStatus() {
  return { type: REQUEST_POLLING_UPI_QR_TRANSACTION_STATUS };
}

function responsePollingUpiQRTRStatus() {
  return { type: RESPONSE_POLLING_UPI_QR_TRANSACTION_STATUS };
}

const getCsrfToken = () => {
  const token = document.cookie.match(
    "(^|[^;]+)\\s*XSRF-TOKEN\\s*=\\s*([^;]+)"
  );
  return token ? token.pop() : "";
};

export function fetchVerifyVpaParams(uuid, vpaReq) {
  return dispatch => {
    dispatch(requestVerifyUpiVPA(uuid, vpaReq.vpa));

    return window
      .fetch(`/public/v1/charge/${uuid}/submit/upi/verifyVPA`, {
        method: "POST",
        body: JSON.stringify(vpaReq),
        headers: {
          "Content-Type": "application/json",
          "X-XSRF-TOKEN": getCsrfToken()
        }
      })
      .then(
        resp => {
          if (resp.status === 400) {
            dispatch(receiveErrorUpiVerifyVpa("Invalid VPA"));
          } else if (!resp.ok) {
            dispatch(receiveErrorUpiVerifyVpa("Could not check VPA"));
          } else {
            resp.json().then(json => {
              dispatch(receiveUpiVerifyResponse(json.customerName, vpaReq.vpa));
            });
          }
        },
        () => dispatch(receiveErrorUpiVerifyVpa("Could not reach server"))
      );
  };
}

export function submitUpiMerchantCollectRequest(uuid, form) {
  return dispatch => {
    dispatch(requestUpiMerchantCollectData(uuid, form.vpa));

    return window
      .fetch(`/public/v1/charge/${uuid}/submit/upi/merchantCollect`, {
        method: "POST",
        body: JSON.stringify(form),
        headers: {
          "Content-Type": "application/json",
          "X-XSRF-TOKEN": getCsrfToken()
        }
      })
      .then(resp => resp.json())
      .then(json => {
        dispatch(receiveUpiMerchantCollectData(json));
        const evtSource = new EventSource(
          `/public/transaction/${json.transactionUuid}/check`
        );
        evtSource.addEventListener("status", () => {
          window.location.assign(`/charge/${uuid}`);
          evtSource.close();
        });
      })
      .catch(error => dispatch(receiveErrorUpiMerchantCollect(error.message)));
  };
}

export function fetchUPIQR(uuid, isAllApps) {
  return dispatch => {
    dispatch(requestUpiQR());

    return window
      .fetch(`/public/charge/${uuid}/upiqr`, {
        method: "GET"
      })
      .then(
        resp => {
          if (resp.status === 400) {
            dispatch(receiveUpiQRError("Invalid VPA"));
          } else if (!resp.ok) {
            dispatch(receiveUpiQRError("Could not check VPA"));
          } else {
            resp.json().then(json => {
              dispatch(receiveUpiQRData(json));
              dispatch(requestPollingUpiQRTRStatus());
              dispatch(responsePollingUpiQRTRStatus());
              if (isAllApps === "true") {
                window.location.assign(json.payload);
              }
            });
          }
        },
        () => dispatch(receiveUpiQRError("Could not reach server"))
      )
      .then(() => {
        const evtSource = new EventSource(`/public/charge/${uuid}/check`);
        evtSource.addEventListener("status", () => {
          window.location.assign(`/charge/${uuid}`);
          evtSource.close();
        });
      });
  };
}

export function resetUPIQR() {
  return dispath => {
    dispath(resetUpiQR());
  };
}

export function submitSimulateCallback(success, chargeId, payapp, totalAmount) {
  // Ensure payapp is in lowercase
  const payappName = payapp.toLowerCase();

  // Use a template literal for constructing the URL
  const url = `/simulator-in/${payappName}/callback/${
    success ? "ok" : "ko"
  }?totalAmount=${encodeURIComponent(totalAmount)}`;

  // Use an object for fetch options for better readability
  const fetchOptions = {
    method: "POST"
  };

  // Use window.fetch directly
  window.fetch(`${url}&chargeId=${encodeURIComponent(chargeId)}`, fetchOptions);
}

export function submitSimulateQRCallback(success, chargeId, payload) {
  const urlParams = new URLSearchParams(payload);
  const vpa = urlParams.get("upi://pay?pa");

  // Use conditional operator to handle null or undefined
  const bankCode = vpa ? vpa.slice(vpa.indexOf("@") + 1) : null;

  const totalAmount = urlParams.get("am");

  let endpoint;
  let dynamicIntentPath = "";

  // Determine endpoint and dynamic intent path based on bank code
  switch (bankCode) {
    case "rbl":
      endpoint = "/simulator-in/rblupi/callback/";
      dynamicIntentPath = "/dynamicIntent";
      break;
    case "kotak":
      endpoint = "/simulator-in/kotakupi/callback/";
      break;
    case "icici":
      endpoint = "/simulator-in/iciciupi/callback/";
      break;
    case "indianbank":
      endpoint = "/simulator-in/indianbank/process/";
      dynamicIntentPath = "/callback";
      break;

    default:
      // Fallback to Kotak if bank code is unrecognized
      endpoint = "/simulator-in/kotakupi/callback/";
  }

  // Construct URL with success/failure status and optional dynamic intent
  let url = `${endpoint}${success ? "ok" : "ko"}${dynamicIntentPath}`;

  // Add query parameters for total amount and charge ID
  url += `?totalAmount=${encodeURIComponent(
    totalAmount
  )}&chargeId=${encodeURIComponent(chargeId)}`;

  // Send POST request
  fetch(url, {
    method: "POST"
  });
}
